import { render } from "./PDFSampleLineBlock.vue?vue&type=template&id=7ef52d10&ts=true"
import script from "./PDFSampleLineBlock.vue?vue&type=script&lang=ts"
export * from "./PDFSampleLineBlock.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__